export const traditionalPromotionMock = {
	recomendacion: 'Ajuste precio por zona',
	cadena: 'Jumbo',
	fase: 'Revisión',
	fechaCreacion: '08/06/2026',
	fechaActualizacion: '08/06/2026 | 11:53',
	margen: '$547.327',
	nroSku: 1,
}

export const traditionalManagementRows = [
	{
		id: '214-C039',
		familia: 'Postres',
		subFamilia: 'Postres Impulso',
		producto: '214',
		descripcion: 'Manjarate Soprole Pote 80 g Black',
		elasticidadProducto: 'Elástico',
		zona: 'C 039',
		tipo: 'Elástico',
		elasticidadPromedioZona: '-2,86',
		precioActual: '$441',
		precioRecomendado: '$441',
		volumenActual: '10.359,05',
		volumenRecomendado: '10.359,05',
		deltaMgValor: '$483.711',
		deltaMgPorcentaje: '34,0%',
		varPrecio: '0,0%',
		varVolumen: '0,0%',
		decision: null,
	},
	{
		id: '214-EXT098',
		familia: 'Postres',
		subFamilia: 'Postres Impulso',
		producto: '214',
		descripcion: 'Manjarate Soprole Pote 80 g Black',
		elasticidadProducto: 'Elástico',
		zona: 'EXT 098',
		tipo: 'Elástico',
		elasticidadPromedioZona: '-2,90',
		precioActual: '$464',
		precioRecomendado: '$464',
		volumenActual: '941,39',
		volumenRecomendado: '941,39',
		deltaMgValor: '$4.286',
		deltaMgPorcentaje: '2,0%',
		varPrecio: '0,0%',
		varVolumen: '0,0%',
		decision: null,
	},
	{
		id: '214-S106',
		familia: 'Postres',
		subFamilia: 'Postres Impulso',
		producto: '214',
		descripcion: 'Manjarate Soprole Pote 80 g Black',
		elasticidadProducto: 'Elástico',
		zona: 'S 106',
		tipo: 'Elástico',
		elasticidadPromedioZona: '-1,10',
		precioActual: '$462',
		precioRecomendado: '$485',
		volumenActual: '1.513,47',
		volumenRecomendado: '1.417,01',
		deltaMgValor: '$29.908',
		deltaMgPorcentaje: '11,0%',
		varPrecio: '5,0%',
		varVolumen: '-6,0%',
		decision: null,
	},
	{
		id: '214-I104',
		familia: 'Postres',
		subFamilia: 'Postres Impulso',
		producto: '214',
		descripcion: 'Manjarate Soprole Pote 80 g Black',
		elasticidadProducto: 'Elástico',
		zona: 'I 104',
		tipo: 'Inelástico',
		elasticidadPromedioZona: '-0,67',
		precioActual: '$462',
		precioRecomendado: '$485',
		volumenActual: '4.272,89',
		volumenRecomendado: '4.226,88',
		deltaMgValor: '$29.422',
		deltaMgPorcentaje: '3,0%',
		varPrecio: '5,0%',
		varVolumen: '-1,0%',
		decision: null,
	},
]

export const traditionalTableColumns = [
	{key: 'familia', label: 'Familia'},
	{key: 'subFamilia', label: 'SubFamilia'},
	{key: 'producto', label: 'Producto'},
	{key: 'descripcion', label: 'Descripción'},
	{key: 'elasticidadProducto', label: 'Elasticidad Producto'},
	{key: 'zona', label: 'Zona'},
	{key: 'tipo', label: 'Tipo'},
	{key: 'elasticidadPromedioZona', label: 'Elasticidad Promedio por Zona'},
	{key: 'precioActual', label: 'Precio Actual (UND)'},
	{key: 'precioRecomendado', label: 'Precio Recomendado (UND)'},
	{key: 'volumenActual', label: 'Volumen Actual (UND)'},
	{key: 'volumenRecomendado', label: 'Volumen Recomendado (UND)'},
	{key: 'deltaMgValor', label: 'Delta Mg $'},
	{key: 'deltaMgPorcentaje', label: 'Delta Mg %'},
	{key: 'varPrecio', label: 'Var%Precio'},
	{key: 'varVolumen', label: 'Var%Vol'},
]

export const traditionalProductDetails = [
	{
		producto: '214',
		zona: 'C 039',
		factor: '0,08',
		umv: '4',
		unit: 'UND',
		tipo: 'Elástico',
		elasticidadPromedio: '-2,8557',
		escalaPrecios: '3',
		margenEmpirico: '$1.402.813',
		precioEscala1: '$441',
		volumenEscala1: '4',
		precioEscala2: '$435',
		volumenEscala2: '12',
		precioEscala3: '$430',
		volumenEscala3: '20',
		margenOptimo: '$1.886.524',
		deltaMgValor: '$483.711',
		deltaMgPorcentaje: '34,0%',
		precioActual: '$441',
		precioRecomendado: '$441',
		volumenActual: '10.359,05',
		volumenRecomendado: '10.359,05',
		varPrecio: '0,0%',
		varVolumen: '0,0%',
	},
	{
		producto: '214',
		zona: 'EXT 098',
		factor: '0,08',
		umv: '4',
		unit: 'UND',
		tipo: 'Elástico',
		elasticidadPromedio: '-2,9029',
		escalaPrecios: '3',
		margenEmpirico: '$178.133',
		precioEscala1: '$464',
		volumenEscala1: '4',
		precioEscala2: '$455',
		volumenEscala2: '12',
		precioEscala3: '$450',
		volumenEscala3: '20',
		margenOptimo: '$182.419',
		deltaMgValor: '$4.286',
		deltaMgPorcentaje: '2,0%',
		precioActual: '$464',
		precioRecomendado: '$464',
		volumenActual: '941,39',
		volumenRecomendado: '941,39',
		varPrecio: '0,0%',
		varVolumen: '0,0%',
	},
	{
		producto: '214',
		zona: 'S 106',
		factor: '0,08',
		umv: '4',
		unit: 'UND',
		tipo: 'Elástico',
		elasticidadPromedio: '-1,1171',
		escalaPrecios: '3',
		margenEmpirico: '$283.288',
		precioEscala1: '$485',
		volumenEscala1: '4',
		precioEscala2: '$475',
		volumenEscala2: '12',
		precioEscala3: '$470',
		volumenEscala3: '20',
		margenOptimo: '$313.196',
		deltaMgValor: '$29.908',
		deltaMgPorcentaje: '11,0%',
		precioActual: '$462',
		precioRecomendado: '$485',
		volumenActual: '1.513,47',
		volumenRecomendado: '1.417,01',
		varPrecio: '5,0%',
		varVolumen: '-6,0%',
	},
	{
		producto: '214',
		zona: 'I 104',
		factor: '0,08',
		umv: '4',
		unit: 'UND',
		tipo: 'Inelástico',
		elasticidadPromedio: '-0,6714',
		escalaPrecios: '3',
		margenEmpirico: '$919.847',
		precioEscala1: '$485',
		volumenEscala1: '4',
		precioEscala2: '$475',
		volumenEscala2: '12',
		precioEscala3: '$470',
		volumenEscala3: '20',
		margenOptimo: '$949.269',
		deltaMgValor: '$29.422',
		deltaMgPorcentaje: '3,0%',
		precioActual: '$462',
		precioRecomendado: '$485',
		volumenActual: '4.272,89',
		volumenRecomendado: '4.226,88',
		varPrecio: '5,0%',
		varVolumen: '-1,0%',
	},
]

export const getTraditionalProductDetail = (row) => {
	return traditionalProductDetails.find((detail) => (
		String(detail.producto) === String(row?.producto) &&
		String(detail.zona).toLowerCase() === String(row?.zona).toLowerCase()
	)) || traditionalProductDetails.find((detail) => String(detail.producto) === String(row?.producto))
}
